module.exports = __webpack_public_path__ + "static/media/3.5b72b056.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/Designbase/assets/3.jpg
// module id = 63
// module chunks = 0